import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

import { SelectionListComponent } from './selection-list.component';

/**
 * Wrapper component for selection list item. It should be used in pcs-selection-list component. We should pass
 * TemplateRef via ng-template for the actual template of the selection item component. The components exposes
 * (via ngTemplateOutletContext) a "selectItem" function that should be used in order to select an item and a
 * "selected" property that indicates whether the item is selected or not.
 *
 * ex.
 * <pcs-selection-list-item>
 *   <ng-template let-active="selected" let-select="selectItem">
 *     <div [ngClass]="{'selected': active}" (click)="select("test")">
 *       Test
 *     </div>
 *   </ng-template>
 * </pcs-selection-list-item>
 */
@Component({
  selector: 'pcs-selection-list-item',
  templateUrl: './selection-list-item.component.html'
})
export class SelectionListItemComponent {
  /**
   * Selection item.
   */
  @Input() item: any;

  /**
   * Optional property that indicates whether the item is selected or not.
   */
  @Input()
  get selected(): boolean {
    return this.selectionList.isSelected(this);
  }
  set selected(value: boolean) {
    if (value !== this._selected) {
      this.setSelected(value);
    }
  }

  private _selected = false;

  @ContentChild(TemplateRef) itemTemplate: TemplateRef<any>;

  selectItem = () => {
    if (this.selected) {
      return;
    }

    this.select();
    this.selectionList.onChange(this);
  };

  constructor(private selectionList: SelectionListComponent) {
  }

  private setSelected(selected: boolean): boolean {
    if (selected === this._selected) {
      return false;
    }

    this._selected = selected;
    this.selectionList.selectItem(this);

    return true;
  }

  private select() {
    this.selected = true;
  }
}
